import { useQuestionsAnswers } from '@/hooks/useQuestionsAnswers';
import theme from '@keyslabor/shared/theme';
import { Box } from '@keyslabor/shared/ui';

interface DashProps {
  active?: boolean;
}

export function Dash({ active }: DashProps) {
  return (
    <Box
      data-testid="nav-dash"
      data-active={active ? 'true' : 'false'}
      width="50px"
      height="6px"
      borderRadius="10px"
      backgroundColor={active ? theme.colors.blueDeeeeep : theme.colors.blueWtf}
    ></Box>
  );
}

export interface TopNavDashesProps {
  /**
   * How many dashes render active. Defaults to `currentQuestionNumber + 1`,
   * which is what the question screens want. The residency gate passes 0: it
   * sits before question 1, so no progress has happened yet.
   */
  activeDashes?: number;
}

export default function TopNavDashes({ activeDashes }: TopNavDashesProps) {
  const { currentQuestionNumber, langContext } = useQuestionsAnswers();
  const activeCount = activeDashes ?? currentQuestionNumber + 1;

  return (
    <Box gap="6px" dxFlex flexDirection="row" justifyContent="center">
      {Array.from({ length: langContext.questionsTotal || 0 }, (_, i) => (
        <Dash key={i} active={i < activeCount} />
      ))}
    </Box>
  );
}
